import { type JSX } from 'react';

import { createFileRoute } from '@tanstack/react-router';

import { CollectionThemesPage } from '@/features/themes/pages/CollectionThemesPage';

export const Route = createFileRoute('/banco-de-temas/colecoes_/$id')({
  component: ColecaoTemasRoute,
});

function ColecaoTemasRoute(): JSX.Element {
  const { id } = Route.useParams();

  const colecaoId = Number(id);
  if (!Number.isInteger(colecaoId) || colecaoId <= 0) {
    throw new Error('Invalid id parameter');
  }

  return <CollectionThemesPage colecaoId={colecaoId} />;
}
